const initialState = {
  pendingTaskId: '',
  totalNominalSortasi: 0,
  attachmentSealList: [],
  attachmentSealListNew: [],
  attachmentUangListNew: [],
  attachmentUangList: [],
  addDataHasilSortasi: [
    {
      jenis: '',
      pecahan: '',
      kualitas: '',
      jumlah: 0,
      nominal: 0,
    },
  ],
  addDataKonfirmasiSelisih: [{}],
  totalKonfirmasiSelisih: 0,
  linkRekamanCctv: '',
  jumlahSortasi: 0,
  addAttachmentSealList: [],
  addAttachmentUangList: [],
  jumlahSelisih: [],
  totalAmount: 0,
  sealSuccess: false,
  moneySuccess: false,
  moneyAttachment:[]
};

const orderCashPickUpSortasiReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PENDING_TASK_ID':
      return {
        ...state,
        pendingTaskId: action.payload,
      };
    case 'RESET_PENDING_TASK_ID':
      return {
        ...state,
        pendingTaskId: action.payload,
      };
    case 'RESET_NOMINAL_SORTASI':
      return {
        ...state,
        nominalSortasi: action.payload,
      };
    case 'SET_TOTAL_NOMINAL_SORTASI':
      return {
        ...state,
        totalNominalSortasi: action.payload,
      };
    case 'RESET_TOTAL_NOMINAL_SORTASI':
      return {
        ...state,
        totalNominalSortasi: action.payload,
      };
    // case 'SET_HASIL_SORTASI':
    //   return {
    //     ...state,
    //     hasilSortasi: action.payload,
    //   };
    // case 'RESET_HASIL_SORTASI':
    //   return {
    //     ...state,
    //     hasilSortasi: action.payload,
    //   };
    // case 'SET_KONFIRMASI_SELISIH':
    //   return {
    //     ...state,
    //     konfirmasiSelisih: action.payload,
    //   };
    // case 'RESET_KONFIRMASI_SELISIH':
    //   return {
    //     ...state,
    //     konfirmasiSelisih: action.payload,
    //   };
    case 'SET_ATTACHMENT_SEAL_LIST':
      return {
        ...state,
        attachmentSealList: action.payload,
      };
    case 'SET_ATTACHMENT_SEAL_LIST_NEW':
      return {
        ...state,
        attachmentSealListNew: action.payload,
      };
    case 'SET_ATTACHMENT_UANG_LIST':
      return {
        ...state,
        attachmentUangList: action.payload,
      };
    case 'SET_ATTACHMENT_UANG_LIST_NEW':
      return {
        ...state,
        attachmentUangListNew: action.payload,
      };
    case 'SET_MONEY_ATTACHMENT':
      return {
        ...state,
        moneyAttachment: action.payload,
      };
    case 'ADD_DATA_HASIL_SORTASI':
      return {
        ...state,
        addDataHasilSortasi: action.payload,
      };
    case 'ADD_DATA_KONFIRMASI_SELISIH':
      return {
        ...state,
        addDataKonfirmasiSelisih: action.payload,
      };
    case 'TOTAL_KONFIRMASI_SELISIH':
      return {
        ...state,
        totalKonfirmasiSelisih: action.payload,
      };
    case 'SET_LINK_REKAMAN_CCTV':
      return {
        ...state,
        linkRekamanCctv: action.payload,
      };
    case 'RESET_ATTACHMENT_SEAL_LIST':
      return {
        ...state,
        attachmentSealList: action.payload,
      };
    case 'RESET_ATTACHMENT_UANG_LIST':
      return {
        ...state,
        attachmentUangList: action.payload,
      };
    case 'RESET_ADD_DATA_HASIL_SORTASI':
      return {
        ...state,
        addDataHasilSortasi: action.payload,
      };
    case 'RESET_ADD_DATA_KONFIRMASI_SELISIH':
      return {
        ...state,
        addDataKonfirmasiSelisih: action.payload,
      };
    case 'RESET_TOTAL_KONFIRMASI_SELISIH':
      return {
        ...state,
        totalKonfirmasiSelisih: action.payload,
      };
    case 'RESET_LINK_REKAMAN_CCTV':
      return {
        ...state,
        linkRekamanCctv: action.payload,
      };
    case 'SET_JUMLAH_SORTASI':
      return {
        ...state,
        jumlahSortasi: action.payload,
      };
    case 'RESET_JUMLAH_SORTASI':
      return {
        ...state,
        jumlahSortasi: action.payload,
      };
    case 'ADD_ATTACHMENT_SEAL_LIST':
      return {
        ...state,
        addAttachmentSealList: action.payload,
      };
    case 'RESET_ADD_ATTACHMENT_SEAL_LIST':
      return {
        ...state,
        addAttachmentSealList: action.payload,
      };
    case 'ADD_ATTACHMENT_UANG_LIST':
      return {
        ...state,
        addAttachmentUangList: action.payload,
      };
    case 'RESET_ADD_ATTACHMENT_UANG_LIST':
      return {
        ...state,
        addAttachmentUangList: action.payload,
      };
    case 'JUMLAH_SELISIH':
      return {
        ...state,
        jumlahSelisih: action.payload,
      };
    case 'RESET_JUMLAH_SELISIH':
      return {
        ...state,
        jumlahSelisih: action.payload,
      };
    case 'SET_SEAL_SUCCESS':
      return {
        ...state,
        sealSuccess: action.payload,
      };
    case 'SET_MONEY_SUCCESS':
      return {
        ...state,
        moneySuccess: action.payload,
      };
    default:
      return state;
  }
};

export default orderCashPickUpSortasiReducers;
